const { isServer } = require('../utils/tracking.util');

/** @type {import('@tidal/tracking').AmplitudeEvents} */
const AMPLITUDE_EVENTS = {
    OFFERWEB_LANDING: 'Offerweb: landingpage',
    OFFERWEB_PRODUCT_SELECTOR: 'Offerweb: product-selector',
    OFFERWEB_PRODUCT_SELECTOR_INAPP_WINBACK: 'Offerweb: product-selector-inapp-winback',
    OFFERWEB_DOWNLOAD: 'Offerweb: download',
    OFFERWEB_PARTNER_CANALDIGITAL: 'Offerweb: Partner-Canal Digital',
    OFFERWEB_DEVICE_FLOW_LINK_CODE: 'Offerweb: link-code',
    OFFERWEB_DEVICE_FLOW_LINK_SUCCESSFUL: 'Offerweb: link-successful',
    OFFERWEB_VOUCHER_LANDING: 'Offerweb: voucher-landingpage',
    OFFERWEB_CAMPAIGN_LANDING: 'Offerweb: campaign-landingpage',
    OFFERWEB_CAMPAIGN_PRODUCT_SELECTOR: 'Offerweb: campaign-product-selector',
    LOGINWEB_CHECKUSER: 'Loginweb: checkuser',
    LOGINWEB_LOGGEDIN: 'Loginweb: loggedin',
    LOGINWEB_USER_CREATED: 'Loginweb: user-created',
    PAYMENTWEB_LANDING: 'Paymentweb: landing',
    PAYMENTWEB_PAYMENT_ADDED: 'Paymentweb: payment-added',
    PAYMENTWEB_SUBSCRIPTION_STARTED_PREMIUM: 'Paymentweb: subscription-started-Premium',
    PAYMENTWEB_SUBSCRIPTION_STARTED_HIFI: 'Paymentweb: subscription-started-Hifi',
    PAYMENTWEB_SUBSCRIPTION_STARTED: 'Paymentweb: subscription-started',
    PAYMENTWEB_EXISTING_PAYMENT_USED: 'Paymentweb: existing-payment-used',
    TIDAL_COM_LANDING: 'Tidalcom: landing-redirect-to-offerweb',
    TIDAL_COM_ABOUT: 'Tidalcom: about-redirect-to-offerweb',
    TIDAL_COM_LANDING_B: 'Tidalcom: landing-redirect-to-offerweb-alt-b',
};

/** @type {import('@tidal/tracking').TrackingWindowInterface} */
let amplitudeWindow;

// if client - get the window object
if (!isServer()) {
    amplitudeWindow = window;
}

/** @type {import('@tidal/tracking').LogAmplitudeEvent} */
const amplitudeLogEvent = (userId, eventMessage, payload) => {
    if (userId) {
        amplitudeWindow.amplitude.getInstance().setUserId(userId);
    }
    amplitudeWindow.amplitude.getInstance().logEvent(eventMessage, payload ? payload : {});
};

/** @type {import('@tidal/tracking').SendAmplitudeEvent} */
const sendEvent = (userId, eventType, payload) => {
    // event type is not supported
    if (!AMPLITUDE_EVENTS[eventType]) {
        console.error(`Tidal Aplitude Mixin Error: eventType: ${eventType} is not supported`);
        return;
    }
    // perform the check of the amplitude state
    if (amplitudeWindow && amplitudeWindow.amplitude && amplitudeWindow.amplitude.amplitudeInitialize) {
        switch (amplitudeWindow.amplitude.amplitudeInitialize) {
            // if initialisation done
            case 'done':
                amplitudeLogEvent(userId, AMPLITUDE_EVENTS[eventType], payload);
                break;
            // if initialisation is still in progress add event listener and send the event when initialised
            case 'running':
                amplitudeWindow.addEventListener('amplitudeInitializeSuccess', () => {
                    amplitudeLogEvent(userId, AMPLITUDE_EVENTS[eventType], payload);
                });
                break;
        }
    }
};

/** @type {import('@tidal/tracking').GetAmplitudeDeviceId} */
const getDeviceId = () => {
    // perform the check of the amplitude state
    if (amplitudeWindow && amplitudeWindow.amplitude && amplitudeWindow.amplitude.amplitudeInitialize) {
        if (amplitudeWindow.amplitude.amplitudeInitialize === 'done') {
            return amplitudeWindow.amplitude.getInstance().options.deviceId;
        }
        return '';
    }
};

module.exports = {
    sendEvent,
    getDeviceId,
    middleware: require('../middleware/amplitude.middleware'),
};
